
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gp/lineas-moviles",
      function () {
        return require("private-next-pages/gp/lineas-moviles/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gp/lineas-moviles"])
      });
    }
  